module.exports = __webpack_public_path__ + "media/images/advisor/img_3_0-9d510f55be40287180a72f7bb0000d28.png";